<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .multi-choice-mapping-row {
    display: grid;
    grid-template-columns:
      utils.in_rem(200px)
      utils.in_rem(59px)
      auto
      utils.in_rem(59px)
      auto;
    align-items: center;

    .field-name {
      @include mixins.body2();
    }
  }
</style>

<script>
  import Icon from "@sourcewhale/shared/svelte-design-system/components/atoms/Icon.svelte";
  import MultiSelectDropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/MultiSelectDropdown/MultiSelectDropdown.svelte";

  import { integrationStore } from "../../../stores";

  export let field;
  export let syncAs;

  $: targetOptions = $integrationStore.getFieldOptions(syncAs);
  $: labels = targetOptions.map((opt) => opt.label);

  const isLabelRepeated = (label) =>
    labels.filter((l) => l === label).length > 1;

  $: items = targetOptions.map((opt) => ({
    value: opt.key === undefined ? "" : String(opt.key),
    id: opt.key === undefined ? "" : String(opt.key),
    label: opt.label,
    description: isLabelRepeated(opt.label) ? String(opt.key) : "",
    required: opt.required,
  }));

  $: key = `${field.key}[]`;

  $: selectedItems = Array.isArray($integrationStore.getFieldValue(key, syncAs))
    ? [...$integrationStore.getFieldValue(key, syncAs)]
    : [];

  $: if (
    JSON.stringify(selectedItems) !==
    JSON.stringify($integrationStore.getFieldValue(key, syncAs) ?? [])
  ) {
    $integrationStore.setFieldValue(key, selectedItems, syncAs);
  }
</script>

<div class="multi-choice-mapping-row">
  <div class="field-name">{field.title}</div>
  <Icon class="fas fa-split"></Icon>
  <!-- Svelte requires the #key block to be reactive to syncAs changing-->
  {#key syncAs}
    <div>
      <MultiSelectDropdown
        placeholder="Select all that apply"
        {items}
        dropdownStyle="width:240px"
        bind:selectedItems
        restrictHeight={true}
      />
    </div>
  {/key}
</div>
